import { comMapping } from '@/components/util/Function/comMapping';

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: 'name',
                label: '规则名称',
                type: 'input'
            },
            {
                prop: 'enable',
                label: '是否启用',
                type: 'select',
                selectval: comMapping.$flag
            },
            {
                prop: 'executeAction',
                label: '执行动作',
                type: 'input'
            },
            {
                prop: 'explain',
                label: '说明',
                type: 'input'
            }
        ],
        searchdata: {
            name: '',
            enable: '',
            executeAction: '',
            explain: ''
        },
        headData: [
            {
                title: '序号',
                prop: 'serialNumber',
                width: 15,
                custom: true

            },
            {
                title: '业务专项',
                prop: 'bsType',
                width: 25,
                custom: true

            },
            {
                title: '业务代码',
                prop: 'code',
                width: 35,
                custom: true

            },
            {
                title: '业务名称',
                prop: 'bsName',
                width: 35,
                custom: true

            },
            {
                title: '取值范围',
                prop: 'resRange',
                width: 35,
                custom: true

            },
            {
                title: '数据类型',
                prop: 'dataType',
                width: 20,
                custom: true

            },
            {
                title: '操作',
                prop: 'cz',
                custom: true,
                fixed: 'right',
                width: 100
            }
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        }
    };
    return obj;
}
